import HttpClient from "../base/http-client";

export default class EmployeeClient extends HttpClient {
  constructor() {
    super("employee", true);
  }
}
